<template>
  <v-container>
    <div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">
      {{ $tc("entities.job.title", 2) }}
    </div>
    <alert-box
      v-model="alert.alerts"
      :type="alert.type"
      @close="alert.alerts = []"
    ></alert-box>
    <btn-a
      v-if="!noAction"
      rounded
      color="primary"
      @click="createJob"
      :access="$access.job.edit"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :search="search"
      :noAction="noAction"
      :multiple="multiple"
      :createAt="true"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.job.title')"
      deleteButton="true"
      @confirm="saveItem(itemSelected, $refs.formEdit.isValid())"
      @delete="deleteItem(itemSelected, true)"
      :loading="loadingDialog"
      :accessConfirm="$access.job.edit"
      :accessDelete="$access.job.delete"
      :alert="form.alert"
      @search="searchTable"
      cancelConfirm
    >
      <jobForm ref="formEdit" v-if="itemSelected" v-model="itemSelected"></jobForm>
    </dialog-d>

    <dialog-d
      ref="dialogCreate"
      :title="$tc('entities.job.forms.create.title', 2)"
      @confirm="saveJob(jobCreateModel, $refs.formCreate.isValid())"
      :loading="loadingDialogCreate"
      @alertClose="alert.alerts = []"
      :accessConfirm="$access.job.edit"
      :accessDelete="$access.job.delete"
      :alert="createJobAlert"
      cancelConfirm
    >
      <jobCreateForm ref="formCreate" v-if="jobCreateModel" v-model="jobCreateModel" />
    </dialog-d>
  </v-container>
</template>

<script>
import jobService from "@/services/jobService.js";
import jobCreateForm from "../components/forms/jobs/jobCreateForm";
import jobForm from "../components/forms/jobs/jobForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";

export default {
  props: {},
  mixins: [pageListMixing],
  components: { jobCreateForm, jobForm },

  data() {
    return {
      apiController: "job",
      entityService: jobService,
      searchFields: [
        "code",
        "description",
        "account.code",
        "account.name",
        "item.code",
        "item.description",
        "status",
        "createAt",
      ],
      loadingDialogCreate: false,
      jobCreateModel: {},
      alert: { alerts: [], type: "error" },
      units: [],
      createJobAlert: {
        alerts: [],
        type: "error",
      },
      headers: [
        {
          text: this.$t("entities.job.props.code"),
          align: "left",
          sortable: false,
          value: "code",
        },
        {
          text: this.$t("entities.job.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: this.$t("entities.job.props.status"),
          align: "left",
          sortable: false,
          value: "status",
        },
        {
          text: this.$t("entities.job.props.date"),
          align: "left",
          sortable: false,
          value: "createAt",
        },
        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.job.edit, this.$access.job.show],
        },
        // {
        //   text: this.$tc("entities.jobStage.title", 2),
        //   icon: "mdi-chevron-right",
        //   handle: this.navigateJobStages,
        //   access: this.$access.jobStage.show
        // },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.job.delete,
        },
      ],
    };
  },
  methods: {
    navigateJobStages(job) {
      this.$router.push({
        name: "Job Stages",
        params: { jobId: job.id },
      });
    },
    async saveJob(job, formIsValid) {
      if (!formIsValid) {
        this.createJobAlert.alerts.push(this.$t("errors.requiredFieldsEmpty"));
        return;
      }
      let res = await this.$http.post("job", job);
      if (!res.success) {
        this.createJobAlert.alerts = res.data;
      } else {
        this.$refs.dialogCreate.open();
        await this.getItems();
      }
    },
    async createJob() {
      this.jobCreateModel = {};
      this.jobCreateModel = await this.getModelDefault();
      this.$refs.dialogCreate.open();
    },
    async getModelDefault() {
      return {
        code: await this.getAutoInc(this.apiController),
        description: "",
        status: "",
        accountId: "",
        environmentId: "",
        versionId: "",
        jobStages: [],
        customFields: {},
        deadline: null,
      };
    },
  },
  async mounted() {
    await this.getItems();
  },
};
</script>
